export function getTotalAmount(row, key, amount = 'amount') {
  const data = row.usages[key] || []
  const primary = row.plan_settings[key]

  if (primary && primary.amount === -1) {
    return '无限制'
  }

  if (data) {
    return data.reduce((total, item) => total + item[amount], 0)
  }
  return 0
}

// 获取主套餐数量
export function getPrimaryAmount(row, key, amount = 'amount') {
  const primary = row.plan_settings[key]
  if (primary && primary.amount === -1) {
    return '无限制'
  }
  return primary ? primary.amount : 0
}

// 获取补充套餐数量
export function getExtraAmount(row, key, amount = 'amount') {
  const data =
    row.usages && row.usages[key]
      ? row.usages[key].filter((item) => !item.primary)
      : ''
  if (data) {
    return data.reduce((total, item) => total + item[amount], 0)
  }
  return 0
}

export function getMaxAmount(row, key, amount = 'amount') {
  const data = row.usages[key]
  const primary = row.plan_settings[key]

  if (primary && primary[amount] === -1) {
    return '无限制'
  }

  if (data) {
    return Math.max(...data.map((t) => t[amount]))
  }
  return 0
}

export function hasPermission(permissions, key) {
  return permissions.split(',').includes(key)
}
